import { DeviceCatalog } from "@services/catalog/types";
import { Device } from "@services/devices/types";
import {
  av_logo,
  codec_logo,
  device_logo,
  gateway_logo,
  laptop_logo,
  monitor_logo,
  projector_logo,
  tablet_logo,
} from "@assets/images";

export const getModelLogo = (
  REACT_APP_SERVER_URL: string,
  device?: Pick<Device, "model" | "type" | "category" | "logo">,
  catalog?: DeviceCatalog
) => {
  if (device === undefined) return device_logo;
  const { model, type, category, logo } = device;
  if (logo) return REACT_APP_SERVER_URL + logo;
  if (model) {
    if (catalog?.deviceModelDetails?.list) {
      for (var i = 0; i < catalog.deviceModelDetails.list.length ?? 0; i++) {
        if (model === catalog.deviceModelDetails.list[i].model) {
          if (catalog.deviceModelDetails.list[i].logo) {
            return `${REACT_APP_SERVER_URL}${catalog.deviceModelDetails.list[i].logo}`;
          }
          break;
        }
      }
    }
  }

  switch (type) {
    case "Codecs":
      if (category === "Single Codecs") return codec_logo;
      break;
    case "Gateway":
      if (category === "Infrastructure") return gateway_logo;
      break;
    case "Computer":
      if (category === "Laptop") return laptop_logo;
      if (category === "Tablet") return tablet_logo;
      break;
    case "AV Devices":
      if (category === "Monitors") return monitor_logo;
      if (category === "Projectors") return projector_logo;
      if (category === "AV Controllers") return av_logo;
      break;
  }
  return device_logo;
};
